import {
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { Respondent, RespondentDTO } from "./respondent";
import { SurveyLinkStatus } from "../types/surveyLinkStatus";
import { SurveyName, SurveyNameDTO } from "../types/surveyName";

export interface RespondentWithSurveyDetailsDTO {
  respondent: RespondentDTO;
  surveyLinkStatus: SurveyLinkStatus.SurveyLinkStatusDTO;
  surveyName?: SurveyNameDTO | null;
}

export class RespondentWithSurveyDetails {
  readonly isRespondentWithSurveyDetailsRespondentWithSurveyDetails: boolean = true;

  readonly respondent: Respondent;
  readonly surveyLinkStatus: SurveyLinkStatus.SurveyLinkStatus;
  readonly surveyName: SurveyName | null;


  constructor(
  respondent: Respondent, 
  surveyLinkStatus: SurveyLinkStatus.SurveyLinkStatus, 
  surveyName: SurveyName | null = null
  ) {
    this.respondent = respondent;
    this.surveyLinkStatus = surveyLinkStatus;
    this.surveyName = surveyName;
  }

  static fromDTO(dto: RespondentWithSurveyDetailsDTO): RespondentWithSurveyDetails {
    const respondent = Respondent.fromDTO(getObject(dto, "respondent", InvalidRespondentWithSurveyDetailsRespondentError));
    const surveyLinkStatus = SurveyLinkStatus.fromDTO(getObject(dto, "surveyLinkStatus", InvalidRespondentWithSurveyDetailsSurveyLinkStatusError));
    let surveyName = getOptionalObject(dto, "surveyName");
    if(surveyName !== undefined && surveyName !== null) {
      surveyName = SurveyName.fromDTO(getObject(dto, "surveyName", InvalidRespondentWithSurveyDetailsSurveyNameError));
    }
    return new RespondentWithSurveyDetails(
      respondent,
      surveyLinkStatus,
      surveyName
    );
  }

  toDTO(): RespondentWithSurveyDetailsDTO {
    const dto: RespondentWithSurveyDetailsDTO = {
        respondent: this.respondent.toDTO(),
        surveyLinkStatus: SurveyLinkStatus.toDTO(this.surveyLinkStatus),
    };
    if (this.surveyName !== undefined && this.surveyName !== null){
      dto.surveyName = this.surveyName.toDTO();
    }
    return dto;
  }
  }

RespondentWithSurveyDetails.prototype.toString = function toString(): string {
  return `RespondentWithSurveyDetails(respondent='${this.respondent}',surveyLinkStatus='${this.surveyLinkStatus}',surveyName='${this.surveyName}')`;
};

export class InvalidRespondentWithSurveyDetailsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentWithSurveyDetailsError";
  }
}
export class InvalidRespondentWithSurveyDetailsRespondentError extends InvalidRespondentWithSurveyDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentWithSurveyDetailsRespondentError";
  }
}

export class InvalidRespondentWithSurveyDetailsSurveyLinkStatusError extends InvalidRespondentWithSurveyDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentWithSurveyDetailsSurveyLinkStatusError";
  }
}

export class InvalidRespondentWithSurveyDetailsSurveyNameError extends InvalidRespondentWithSurveyDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentWithSurveyDetailsSurveyNameError";
  }
}
